import React from 'react';
import firebase from 'firebase';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Moment from 'moment';

class Coupons extends React.Component {

  state = { 
    user: localStorage.currentUser, 
    type:localStorage.type
  };

  componentDidMount() {
    this.getItems();
  }

  getItems () {
    var items = firebase.database().ref('coupons');
    var itemArray = [];

    if(this.state.type === 'business') {

      items.orderByChild('promotion/userUid').equalTo(this.state.user).once('value', (data) => {
        var object = data.val();
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            object[key].key = key;
            itemArray.push(object[key]);
          }
        }
        this.setState({items:itemArray});
      });
    
    } else if(this.state.type === 'user') {
      
      items.orderByChild('createdBy').equalTo(this.state.user).once('value', (data) => {
        var object = data.val();
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            itemArray.push(object[key]);
          }
        }
        this.setState({items:itemArray});
      });

    } else if(this.state.type === 'admin') {
      
      items.once('value', (data) => {
        var object = data.val();
        for (var key in object) {
          if (object.hasOwnProperty(key)) {
            itemArray.push(object[key]);
          }
        }
        this.setState({items:itemArray});
      });

    }
  }

  promotionTitle(cell, row) { return row.promotion ? row.promotion.title : 'No name'; }
  promotionCompany(cell, row) { return row.promotion ? row.promotion.company.companyName : 'No name'; }
  issuer(cell, row) { 
    if(row.createdByUser) {
      return `${row.createdByUser.firstName} ${row.createdByUser.lastName}`;
    } else {
      return `${row.createdBy}`;
    }
  }
  redeemedStatus(cell, row) { return row.redeemed ? Moment(row.redeemedAt).format('Do MMM YY HH:mm') : 'Not Redeemed'; }
  createdAt(cell, row) { return cell ? Moment(cell).format('Do MMM YY HH:mm') : 'N/A' }
  customerEmail(cell, row) { return row.customer ? row.customer.email : 'No email'; }
  multiUseCoupon(cell, row) { 
    return row.multiuse ? <a href={'https://api.qrserver.com/v1/create-qr-code/?size=400x400&data='+row.key} target="_blank">View QR code</a> : '-' 
  }
  redeemedCount(cell, row) { return row.multiuse ? row.redeemed : '-' }

  render()  {
    return (
      <div>

       <BootstrapTable data={this.state.items}   exportCSV={ true } options={ {defaultSortName: 'createdAt', defaultSortOrder: 'desc' } } pagination striped hover>
          <TableHeaderColumn isKey dataField='promotion' dataFormat={this.promotionTitle} csvFormat={this.promotionTitle}>Promotion</TableHeaderColumn>
          <TableHeaderColumn dataField='promotion' dataFormat={this.promotionCompany} csvFormat={this.promotionCompany}>Promotion By</TableHeaderColumn>
          <TableHeaderColumn dataField='createdByUser' dataFormat={this.issuer} csvFormat={this.issuer}>Issuer</TableHeaderColumn>
          <TableHeaderColumn dataField='redeemed' dataSort dataFormat={this.redeemedStatus} csvFormat={this.promotionTitle}>Redeemed</TableHeaderColumn>
          <TableHeaderColumn dataField='createdAt' dataFormat={this.createdAt} dataSort>Created on</TableHeaderColumn>
          <TableHeaderColumn dataField='customer' dataFormat={this.customerEmail} csvFormat={this.customerEmail}>Customer email</TableHeaderColumn>
          <TableHeaderColumn dataField='multiuse' dataFormat={this.multiUseCoupon}>Multi-use coupon</TableHeaderColumn>
          <TableHeaderColumn dataField='redeemed' dataFormat={this.redeemedCount}>Redeemed Count</TableHeaderColumn>
        </BootstrapTable>

      </div>
    );
  }
}

export default Coupons;


// WEBPACK FOOTER //
// ./src/containers/Coupons.js